<template>
  <tr class="hover:bg-gray-50 cursor-pointer" @click="modalShow">
    <td class="px-6 py-4">
      <div class="flex items-center">
        <div class="flex-shrink-0 h-10 w-10">
          <img
              class="h-10 w-10 rounded-full"
              :src="image"
          >
        </div>
        <div class="ml-4">
          <div class="text-sm font-medium">
            {{ name }}
          </div>
          <div class="text-sm text-gray-900">
            {{ id }}
          </div>
        </div>
      </div>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
      {{ countedStock }} / {{ sales }}
    </td>
  </tr>
</template>

<script>
import Product from './Product';
export default Product;
</script>